"use client";

import { useTranslations } from "next-intl";
import type { ReactElement } from "react";
import { CareersRecruiteeEmbed } from "../../_components/careers-recruitee-embed";

/** Verbatim Recruitee embed config for engineering roles only — do not
 * restyle; it's the account's own widget setup (Softwareentwicklung dept). */
const RECRUITEE_ENGINEERING_WIDGET_CONFIG = {
  companies: ["yls375yynt"],
  detailsMode: "popup",
  language: "en",
  departmentsFilter: ["Softwareentwicklung"],
  tagsFilter: [],
  themeVars: {
    primary: "#000000",
    secondary: "#141217",
    text: "#5d566c",
    textDark: "#141217",
    fontFamily:
      '"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;',
    baseFontSize: "16px",
  },
  flags: {
    showLocation: true,
    showCountry: true,
    showCity: true,
    showState: false,
    showLocationName: true,
    showWorkModel: true,
    groupByLocation: false,
    groupByState: false,
    groupByDepartment: false,
    groupByCompany: false,
  },
};

/** Live engineering openings (Recruitee widget, filtered to the
 * Softwareentwicklung department) on a white panel — anchor for every
 * jobs CTA on this page. */
export function Engineering2JobsSection(): ReactElement {
  const t = useTranslations("public.engineering2JobsSection");
  return (
    <section id="jobs" className="dvf-section c2-center">
      <div className="dvf-section-inner">
        <h2 className="dvf-section-title">{t("openEngineeringRoles")}</h2>
        <CareersRecruiteeEmbed config={RECRUITEE_ENGINEERING_WIDGET_CONFIG} />
      </div>
    </section>
  );
}
